module.exports = __webpack_public_path__ + "static/img/personIcon-inactive.4ff3672.svg";